import React, { useState, useEffect } from 'react';
import { BillingInfo } from './Billing';
import { Templates } from './Template';
import moment from "moment-timezone";
import { toast } from "react-toastify"
import useDeepVinApi from '../hook/useDeepvinApi';
import useAuth from '../hook/useAuth';
import { isNumberField } from './utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPlus } from "@fortawesome/free-solid-svg-icons"
import { Tooltip } from "react-tooltip"
import ReactJson from "@microlink/react-json-view";
import { useLocation } from "react-router-dom";
import BsTab from "bootstrap/js/dist/tab";

const TimeZoneNameMap = {
  "UTC": "UTC",
  "Eastern": "America/New_York",
  "Central": "America/Chicago",
  "Mountain": "America/Denver",
  "Pacific": "America/Los_Angeles",
  "Alaska": "America/Anchorage",
  "Hawaii": "Pacific/Honolulu",  
}
export const CurrentTimeFormat = "L hh:mm a"

export const TimeZoneAbbr = (auth) =>{
  let tzAbbr = "UTC"
  if (auth && auth.Settings) {
    let tzSetting = auth.Settings.find(us => us.FieldName === "TimeZone")
    if (tzSetting !== null) {
      let tzs = tzSetting.FieldValues.split(',')
      tzAbbr = (tzSetting.Value === null || tzSetting.Value < 1 || tzSetting.Value > tzs.length) ?
      "UTC" : tzs[tzSetting.Value -1]
    }    
  }

  return tzAbbr
}

export const CurrentTimeZoneName = (auth) => {
  return TimeZoneNameMap[TimeZoneAbbr(auth)] 
}

export const TimeStringForTimeZone = (auth, t) => {
  return timeForTimeZone(t, TimeZoneAbbr(auth)).format(CurrentTimeFormat)
}

const timeForTimeZone = (t, z) => {
  return moment(t).tz(TimeZoneNameMap[z], false)
}

export const Settings = () => {
  
  return (
    <>
    <h1 class="mb-3">Account Settings</h1>
    <AdminSettings />
    {/* <hr />
    <div class="row">
      <div class="col-6">
        <LabelSettings />
      </div>
      <div class="col-6">
      </div>
    </div> */}
  </>
  )
}

export const AdminSettings = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab") || location.hash.replace("#", "") || "report";

    if (tabParam) {
      const target = document.querySelector(`[data-bs-target="#${tabParam}"]`);
      if (target) {
        const tab = new BsTab(target);
        tab.show();
      }
    }
  }, [location.search, location.hash]);


  return (
    <>
    <div class="row">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active internal-tab" id="report-tab" data-bs-toggle="tab" data-bs-target="#report" type="button" role="tab" aria-controls="report" aria-selected="false">Report Template</button>
        </li>
        {/* <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab" aria-controls="review" aria-selected="false">QA Review Template</button>
        </li> */}
        <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="label-tab" data-bs-toggle="tab" data-bs-target="#case-labels" type="button" role="tab" aria-controls="case-labels" aria-selected="false">Case Labels</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="policy-tab" data-bs-toggle="tab" data-bs-target="#policy" type="button" role="tab" aria-controls="policy" aria-selected="false">Account Policy</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="acct-tab" data-bs-toggle="tab" data-bs-target="#acct" type="button" role="tab" aria-controls="acct" aria-selected="false">Other Settings</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="billing-tab" data-bs-toggle="tab" data-bs-target="#billing" type="button" role="tab" aria-controls="billing" aria-selected="false">Billing</button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="report" role="tabpanel" aria-labelledby="report-tab">
          <Templates />
        </div>
        <div class="tab-pane fade" id="case-labels" role="tabpanel" aria-labelledby="label-tab">
          <LabelSettings />
        </div>
        {/* <div class="tab-pane fade" id="review" role="tabpanel" aria-labelledby="review-tab">
          <Template type={2} />
        </div> */}
        <div class="tab-pane fade" id="policy" role="tabpanel" aria-labelledby="policy-tab">
          <AccountPolicy />
          {/* <h3>Account logo</h3>
          <h3>Centralized device list and passwords control</h3>
          <h3>Limit users to access their own files only. Yes/No</h3> */}
        </div>
        <div class="tab-pane fade" id="acct" role="tabpanel" aria-labelledby="acct-tab">
          <AccountSettings />
        </div>
        <div class="tab-pane fade" id="billing" role="tabpanel" aria-labelledby="billing-tab">
          <BillingInfo />
        </div>
      </div>
    </div>
    {/* <ReactJson src={data} collapsed={1} /> */}
    </>
  )
}

export const LabelSettings = () => {
  const api = useDeepVinApi()
  const [caseLabels, setCaseLabels] = useState([])
  const [newLabelName, setNewLabelName] = useState('')

  useEffect(() => {
    api.get('/api/label/')
    .then(response => setCaseLabels(response.data))
    .catch(error => console.error("Error fetching labels: ", error));
  }, [])

  const handleRemove = (name) => {
    if (!window.confirm(`This will also remove the label from all associated cases. Are you sure to continue?`)) return
    
    api.delete(`/api/label/delete/${name}`)
    .then(() => {
        // Refresh the list or filter out the deleted item locally
        setCaseLabels(prevLabels => prevLabels.filter(label => label.Name !== name));
    })
    .catch(error => console.error("API error: ", error))
  }

  const handleAdd = () => {

    const trimmedInput = newLabelName.trim();
    // Check if the trimmed input is empty
    if (trimmedInput === "") {
        alert("The new labelinput cannot be empty or just white spaces.")
        return
    }

    if (caseLabels.some(label => label.Name === trimmedInput)) {
      alert('This label name already exists!')
      return
    }

    api.post('/api/label/update', {Name: trimmedInput})
    .then(response => {
          setCaseLabels(prevLabels => [...prevLabels, response.data]);
          setNewLabelName('')
      })
    .catch(error => console.error("Error adding new label: ", error));
  }

  return (
    <>
    <h3 class="mt-3 mb-3">Existing Labels</h3>
    <div>
      <ul>
        {caseLabels.map(label => (
          <li key={label.ID}>
              <button class="btn btn-outline-secondary btn-sm me-3 py-0" onClick={() => handleRemove(label.Name)}><FontAwesomeIcon icon={faTrashCan}/></button>
              {label.Name}
          </li>
        ))}
      </ul>
      <div class="row">
        <div class="col-lg-6 col-sm-6">
          <div class=" input-group mb-3">
            <button class="btn btn-outline-secondary btn-sm me-3 py-0" id="btn-add-label" onClick={handleAdd}><FontAwesomeIcon icon={faPlus} /></button>
            <input class="form-control form-control-sm"
              type="text"
              value={newLabelName}
              onChange={(e) => setNewLabelName(e.target.value)}
              placeholder="New label name"
            /> 
          </div>
        </div>
      </div>

    </div>
    <Tooltip anchorSelect="#btn-add-label" place="top">Add new label</Tooltip>
    {/* <ReactJson src={{caseLabels}} /> */}
    </>
  )
}

export const UserSettings = ({}) => {
  const { auth, setAuth } = useAuth()
  const api = useDeepVinApi()
  const [settings, setSettings] = useState({})

  useEffect(() => {
    setSettings(auth.Settings)
  }, [auth])

  const onValueChange = (id, desciption, variables, value) => {
    let vs = [...settings] // DON'T point to (ie vs = data), MAKE A COPY!!!
    vs = updateField(vs, id, desciption, variables, value)
    setSettings(vs)
  }

  const onSave = (e) => {
    let vs = [...settings] 
    api.post(`/api/setting/user`, vs)
    .then(({data}) => {
      setSettings(data.Settings)
      setAuth(data)
      toast.success("User Settings are saved!")
    })
    .catch(error => console.error("Error: ", error))
  }

  return (    
    <>
    <div class="card">
      <h4 class="card-header text-center">User Settings</h4>
      {settings && settings.length > 0 && 
        <div class="card-body">
          <SettingFields ss={settings} onValueChange={onValueChange} />
        </div>
      }
      <div class="d-grid gap-2 col-2 mx-auto card-body">
        <button onClick={onSave} type="submit" class="btn btn-primary">Save</button>
      </div>
    </div>
    {/* <ReactJson src={{settings}} collapsed="3" /> */}
    </>
  )
}

export const AccountPolicy = ({}) => {
  const { auth } = useAuth()
  const api = useDeepVinApi()
  //const [policy, setPolicy] = useState()
  const [retentionDays, setRetentionDays] = useState(365)
  const [autoDelete, setAutoDelete] = useState(false)
  const [mobileUploadAll, setMobileUploadAll] = useState(false)
  const [mobileLoginRequired, setMobileLoginRequired] = useState(false)
  const [manualDeleteFromDevice, setManualDeleteFromDevice] = useState(false)
  const [manualDownloadFromDevice, setManualDownloadFromDevice] = useState(true)
  const [manualDeleteFromApp, setManualDeleteFromApp] = useState(false)
  const [mobileProviderInput, setMobileProviderInput] = useState(false)

  useEffect(() => {
    api.get("/api/account/policy")
    .then(({data}) => {
      setRetentionDays(data.RetentionDays)
      setAutoDelete(data.AutoDeleteAfterUpload)
      setMobileLoginRequired(data.MobileLoginRequired)
      setMobileUploadAll(data.MobileUploadAll)
      setManualDeleteFromDevice(data.ManualDeleteFromDevice)
      setManualDownloadFromDevice(data.ManualDownloadFromDevice)
      setManualDeleteFromApp(data.ManualDeleteFromApp)
      setMobileProviderInput(data.AllowProviderInputFromApp)
    })
    .catch(error => {
        setRetentionDays(365)
        setAutoDelete(false)
        setMobileLoginRequired(false)
        setMobileUploadAll(false)
        setManualDeleteFromDevice(false)
        setManualDownloadFromDevice(false)
        setManualDeleteFromApp(false)
        setMobileProviderInput(false)
        console.error("API error: ", error)
    })
  }, [])
/*
  const onDeletePolicyChange = (id, desciption, variables, value) => {
    if (value === 1){
      if (!window.confirm("This policy setting will automatically delete original files from the device after they are downloaded to the mobile app. Click OK to confirm!"))
        return
    }
    setAutoDelete(value === 1)
  }
  const onMobileLoginPolicyChange = (id, desciption, variables, value) => {
    setMobileLoginRequired(value === 1)
  }
  const onMobileUploadPolicyChange = (id, desciption, variables, value) => {
    setMobileUploadAll(value === 1)
  }
*/

  const onManualDeviceDeletePolicyChange = (id, desciption, variables, value) => {
    if (value === 1){
      if (!window.confirm("This policy setting will allow the mobile app user to delete original files from the device. PLEASE USE CAUTION! Click OK to confirm."))
        return
    }
    setManualDeleteFromDevice(value === 1)
  }
  const onManualDownloadPolicyChange = (id, desciption, variables, value) => {
    setManualDownloadFromDevice(value === 1)
  }

  const onManualProviderInputPolicyChange = (id, desciption, variables, value) => {
    setMobileProviderInput(value === 1)
  }

  const onManualAppDeletePolicyChange = (id, desciption, variables, value) => {
    if (value === 1){
      if (!window.confirm("This policy setting will allow the mobile app user to delete files within the app. Click OK to confirm!"))
        return
    }
    setManualDeleteFromApp(value === 1)
  }

  const handleBlur = (e) => {
    if (e.target.value < 30) {
      setRetentionDays(30)
      alert("The minimum retention period is 30 days.")
    }
  }

  const onRetentionChange = (e) => {
    if (e.target.value < 0) { return }
    setRetentionDays(Number.parseInt(e.target.value, 10))
  }

  const onSave = (e) => {
    api.post(`/api/account/policy`, {
        RetentionDays: retentionDays,
        AutoDeleteAfterUpload: autoDelete,
        MobileLoginRequired: mobileLoginRequired,
        MobileUploadAll: mobileUploadAll,
        ManualDeleteFromDevice: manualDeleteFromDevice,
        ManualDownloadFromDevice: manualDownloadFromDevice,
        ManualDeleteFromApp: manualDeleteFromApp,
        AllowProviderInputFromApp: mobileProviderInput
      })
    .then(({data}) => {
      console.log("Account policy is saved!")
      toast.success("Account policy is saved!")
    })
    .catch(error => console.error("Error: ", error))
  }

  //const asn = auth.Account.ShortName
  //const useMobileSetting = asn === "garlandfd" || asn === "MCHD" || asn === "uemedical"
  // if (policy)
  return (    
    <>
    <div class="card mt-3">

        <div class="card-body">
          {/*useMobileSetting && */<h4 class="mt-5 mb-3">Mobile App</h4>}
              {/* <div class="mb-2 row">
                <label for="manualdeletedevice" class="col-sm-3 col-form-label bg-warning text-dark">
                  <FontAwesomeIcon icon={faWarning} /> Allow Mobile App User to Select Files to Delete from Device!</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ manualDeleteFromDevice ? 1 : 2}
                    onValueChange={onManualDeviceDeletePolicyChange} />
                  </div>
                </div>
              </div>
              <div class="mb-2 row">
                <label for="manualdeleteapp" class="col-sm-3 col-form-label bg-warning text-dark">
                  <FontAwesomeIcon icon={faWarning} /> Allow Mobile App User to Delete Files in the App!</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ manualDeleteFromApp ? 1 : 2}
                    onValueChange={onManualAppDeletePolicyChange} />
                  </div>
                </div>
              </div> */}
              {/*useMobileSetting && */<div class="mb-2 row">
                <label for="manualdownloaddevice" class="col-sm-3 col-form-label text-dark">
                  Allow Mobile App User to Select Files to Download from Device</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ manualDownloadFromDevice ? 1 : 2}
                    onValueChange={onManualDownloadPolicyChange} />
                  </div>
                </div>
              </div>}
              <div class="mb-2 row">
                <label for="allowproviderinputfromapp" class="col-sm-3 col-form-label text-dark">
                  Allow Mobile App User to Add Field Info While Uploading Files</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ mobileProviderInput ? 1 : 2}
                    onValueChange={onManualProviderInputPolicyChange} />
                  </div>
                </div>
              </div>
              {/* <div class="mb-2 row">
                <label for="autodelete" class="col-sm-3 col-form-label bg-warning text-dark">
                  <FontAwesomeIcon icon={faWarning} /> Auto Delete Files From Device After Upload</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ autoDelete ? 1 : 2}
                    onValueChange={onDeletePolicyChange} />
                  </div>
                </div>
              </div> 
              <div class="mb-2 row">
                <label for="loginrequired" class="col-sm-3 col-form-label">Login Required</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ mobileLoginRequired ? 1 : 2}
                    onValueChange={onMobileLoginPolicyChange} />
                  </div>
                </div>
              </div>
              <div class="mb-2 row">
                <label for="uploadall" class="col-sm-3 col-form-label">Upload All Files</label>
                <div class="col-sm-6">
                  <div class="input-group">
                  <InputField fid={-1} fType="bool" fval={ mobileUploadAll ? 1 : 2}
                    onValueChange={onMobileUploadPolicyChange} />
                  </div>
                </div>
              </div> */}

          <h4 class="mt-5 mb-3">Storage</h4>
              <div class="mb-2 row">
                <label for="retentiondays" class="col-sm-3 col-form-label">Retention for Videos (minimum 30 days)</label>
                <div class="col-sm-2">
                  <div class="input-group">
                  <input type="number" class="col-sm-2 form-control form-control-sm mb-1"
                  value={retentionDays} min={30} onBlur={handleBlur}onChange={onRetentionChange}
                  onWheel={(e) => e.target.blur()} />
                  </div>
                </div>
              </div>

          {/* <div class="form-group row">
            <div class="col-sm-6">
                <label class="fw-bold col-form-label">Retention for Uploaded Videos (days)</label>
            </div>
            <div class="col-sm-6">
                <input type="number" class="form-control form-control-sm mb-1" value={retentionDays} onChange={onRetentionChange} />
            </div>
          </div> */}
        
        </div>
      
      <div class="d-grid gap-2 col-2 mx-auto card-body">
        <button onClick={onSave} type="submit" class="btn btn-primary">Save</button>
      </div>

    </div>
    {/* <ReactJson src={{settings}} collapsed="3" /> */}
    </>
  )
}

export const AccountSettings = ({}) => {
  const api = useDeepVinApi()
  const [settings, setSettings] = useState({})

  useEffect(() => {
    api.get(`/api/setting/account`)
    .then(({data}) => setSettings(data))
    .catch(error => console.error("Error: ", error))
  }, [])

  const onValueChange = (id, desciption, variables, value) => {
    let vs = [...settings] // DON'T point to (ie vs = data), MAKE A COPY!!!
    vs = updateField(vs, id, desciption, variables, value)
    setSettings(vs)
  }  

  const onSave = (e) => {
    let vs = [...settings] 
    api.post(`/api/setting/account`, vs)
    .then(({data}) => {
      setSettings(data)
      toast.success("Account Settings are saved!")
    })
    .catch(error => console.error("Error: ", error))
  }

  return (    
    <>
    <div class="card mt-3">
      {/* <h4 class="card-header text-center">Account Settings</h4> */}
   
      {settings && settings.length > 0 && 
        <div class="card-body">
          <SettingFields ss={settings} onValueChange={onValueChange}/>
        </div>
      }
      
      <div class="d-grid gap-2 col-2 mx-auto card-body">
        <button onClick={onSave} type="submit" class="btn btn-primary">Save</button>
      </div>

    </div>
    {/* <ReactJson src={{settings}} collapsed="3" /> */}
    </>
  )
}

export const GroupField = ({parent, children, onValueChange}) => {
  console.log("group: ", parent)
  console.log("children: ", children)
  if (parent.FieldType === "group" && children && children.length >0)
  return (
    <>
    <hr />
    <div class="row mb-1">
      <label class="fw-bold form-label col-12">{parent.Description}</label>
      <div class="row" style={{'margin-left': '10px'}}>
        {children.map((field) => 
          <SingleField field={field} onValueChange={onValueChange} />
        )}
      </div>
    </div>
    {/* <ReactJson src={{parent}} collapsed={3} /> */}
    <hr />
    </>
  )
}

export const SingleField = ({ field, onValueChange }) => {
  if (field && field.Enabled)
  return (
    <>
    {field.FieldType!=="bool" && !isNumberField(field.FieldType) && 
    field.FieldValues && field.FieldValues.split(',').length > 0 
    ? <ValueSelector fid={field.ID} description={field.Description}
                      values={field.FieldValues.split(',')} val={field.Value} 
                      onValueChange={onValueChange} />
    : <InputField fid={field.ID} fType={field.FieldType} 
                  description={field.Description}
                  fval={field.Value}
                  onValueChange={onValueChange} />
    }
    </>
  )
}

export const ValueSelector = ({fid, description, values, val, onValueChange}) => {

  const handleSelect = (e) => {
    onValueChange(fid, description, null, parseInt(e.target.value)) 
  }

  if (values)
  return (
    <div class="form-group row">
      <div class="col-sm-6">
          <label class="fw-bold col-form-label">{description}</label>
      </div>
      <div class="col-sm-6">
        <select class="form-select"
          value={val}
          onChange={handleSelect}>
            {/* <option selected>Pick a</option> */}
            {values.map((val, i) => <option value={i+1}>{val}</option>)}
        </select>
      </div>
    </div>
  )
}

export const InputField = ({fid, fType, description, fval, onValueChange}) => {

  // this is used in Setting, AccountSettings, UserSettings
  let inType = "text"
  if ( fType === "int" || fType === "float" || fType === "decimal" || fType === "integer"
      || fType === "double" || fType === "unit") {
    inType = 'number'
  } else if (fType === 'password' || fType === 'file'){
    inType =  fType
  } else if (fType === 'bool'){
    inType = 'checkbox'
  }
  
  const onChange = (e) => {
    if (inType === "file") {
      onValueChange(fid, description, null, e.target.files)
      //e.target.value = null
    } else if (inType === 'checkbox') {
      onValueChange(fid, description, null, e.target.checked ? 1 : 2)
    } else {
      onValueChange(fid, description, null, e.target.value)      
    }
  }

  if (fType !== "group")
  return (
    <>
    <div class="form-group row">
      <div class="col-sm-6">
        {inType === 'file' && fval
          ? <div>
              <label class="fw-bold col-form-label">{description}</label>
              <img src={fval} alt="" width="32" height="32" class="rounded-circle me-2" />
            </div>
          : <div><label class="fw-bold col-form-label">{description}</label></div>
        }
      </div>
      <div class="col-sm-6">
        {inType === 'file' 
          ? <input type={inType} class="form-control form-control-sm mb-1" 
                    accept="image/png,image/jpeg,image/svg+xml,.png,.jpg,.jpeg,.svg" onChange={onChange} />
          : inType === 'checkbox'
            ? <input type={inType} class="form-check-input mb-1" checked={fval===1} onChange={onChange} />
            : <input type={inType} class="form-control form-control-sm mb-1" value={fval} onChange={onChange} />
        }
      </div>
    </div>
    {/* <ReactJson src={{field}} collapsed={1} /> */}
    </>
  )
}

const SettingFields =({ss, onValueChange}) =>{

  var groupFields = {}
  useEffect(() => {
    getGroupFields()
  }, [ss])

  const getGroupFields = () => {
    if(ss && ss.length > 0) {
      ss.filter(v => v.Enabled && v.FieldType==="group").map(field =>{
        groupFields[field.FieldName]=[]
        for (const fn of field.FieldValues.split(',')){
          groupFields[field.FieldName].push(ss.filter(f=>f.FieldName === fn)[0])
        }
      })
    }
    // console.log("in getGroupFields: ", groupFields)
  }

  const isGroupChild = (name) =>{
    if (Object.keys(groupFields).length === 0) {
      getGroupFields()
    }

    for (const [parent, children] of Object.entries(groupFields)){
      for (const field of children){
        if(field.FieldName === name){
          // console.log("fieldname found: ", name)
          return true          
        }
      }
    }
    // console.log("fieldname not found: ", name)
    return false
  }

  if(ss && ss.length > 0) 
  return(
  <>
    <div>
      {ss.filter(v => v.Enabled && v.FieldType !== "group" 
      && !isGroupChild(v.FieldName)).map(field => 
        <SingleField field={field} onValueChange={onValueChange} />)
      }
    </div>

    <div>
      {groupFields && Object.keys(groupFields).length > 0 && 
        ss.filter(v => v.Enabled && v.FieldType === "group").map(field => 
        <GroupField parent={field} children={groupFields[field.FieldName]} onValueChange={onValueChange} />)
      }
    </div>
    {/* <ReactJson src={{groupFields}} collapsed={3} /> */}
  </>
  )
}

const updateField = (vs, id, desciption, variables, value) =>{
  let index = vs.findIndex(v => v.ID === id)
  if (index === -1) {
    return vs // vs.push({FieldDescription: desciption, FieldValueList: variables, Value: value}) // new data
  } else {
    vs[index].FieldDescription = desciption
    vs[index].FieldValueList = variables
    if (vs[index].FieldType === "file"){
      getFileString(value[0], vs[index]) // value is "e.target.files"
      console.log('******** file vs[index].Value:', vs[index].Value);
    } else {
      vs[index].Value =  value
    }
  
    return vs
  }
}

const getFileString = async (file, field) => {
  // console.log("****** logo file: ", file)
  // const reader = new FileReader()
  // reader.readAsDataURL(file)
  // if(reader.readyState === 2) {// Done
  //   console.log("****** reading logo result: ", reader.result)
  //   //const strBase64 = reader.result.split(',')[1]
  //   return reader.result
  // } else {
  //   console.log("****** reading logo error: ", reader.err)
  //   return ""
  // }

  try {
    field.Value = await readFileAsText(file)
    // Now you can call other functions or perform additional tasks with the logoText
    //console.log('******** reading file result:', field.Value);
  } catch (error) {
    console.error('Error:', error);
  }
}

const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const strResult = event.target.result; // Get the text content
      resolve(strResult)//.split(',')[1]);//reader.result.split(',')[1]
    };

    reader.onerror = (event) => {
      // Reject the promise if an error occurs
      reject(event.target.error);
    };

    reader.readAsDataURL(file); // Read the selected file as text
  })

}
